import { Button } from "@/components/ui/button";

/**
 * Page footer pagination — server-paginated. Only renders when
 * there's at least one row of data; total_pages can still be 1 and
 * that's fine (we render disabled buttons + the count line).
 */
export default function BrandsPagination({
  page, pageSize, totalCount, totalPages, networkFilter, onPageChange,
}) {
  if (totalCount <= 0) return null;
  return (
    <div className="flex items-center justify-between mt-4 px-1 text-xs text-slate-600" data-testid="brands-pagination">
      <div>
        Showing{" "}
        <span className="font-mono font-semibold text-slate-900">
          {((page - 1) * pageSize) + 1}–{Math.min(page * pageSize, totalCount)}
        </span>{" "}
        of <span className="font-mono font-semibold text-slate-900">{totalCount.toLocaleString()}</span>
        {networkFilter !== "all" ? ` ${networkFilter} ` : " "}brand{totalCount === 1 ? "" : "s"}
      </div>
      <div className="flex items-center gap-2">
        <Button
          size="sm" variant="outline" className="h-7 text-xs"
          disabled={page <= 1}
          onClick={() => onPageChange(Math.max(1, page - 1))}
          data-testid="brands-prev-page"
        >
          ← Prev
        </Button>
        <span className="text-slate-500 px-1">
          Page <span className="font-mono font-semibold text-slate-900">{page}</span> of {totalPages}
        </span>
        <Button
          size="sm" variant="outline" className="h-7 text-xs"
          disabled={page >= totalPages}
          onClick={() => onPageChange(Math.min(totalPages, page + 1))}
          data-testid="brands-next-page"
        >
          Next →
        </Button>
      </div>
    </div>
  );
}
